var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoDockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.05C4.46957 16.05 3.96086 15.7961 3.58579 15.3441C3.21071 14.8922 3 14.2792 3 13.64V6.41C3 5.77083 3.21071 5.15784 3.58579 4.70587C3.96086 4.25391 4.46957 4 5 4H15C15.5304 4 16.0391 4.25391 16.4142 4.70587C16.7893 5.15784 17 5.77083 17 6.41V13.64C17 14.2792 16.7893 14.8922 16.4142 15.3441C16.0391 15.7961 15.5304 16.05 15 16.05H5ZM15.5 10.025V6.41C15.5 6.25021 15.4473 6.09696 15.3536 5.98397C15.2598 5.87098 15.1326 5.8075 15 5.8075H5C4.86739 5.8075 4.74021 5.87098 4.64645 5.98397C4.55268 6.09696 4.5 6.25021 4.5 6.41V10.025H15.5Z",
    fill: "#002d62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoDockIcon);
export default __webpack_public_path__ + "static/media/so_dock_icon.a0ad5db58d4484d71d364f8f1b07cdda.svg";
export { ForwardRef as ReactComponent };